/** @jsx h */
import { h } from 'preact'
import ExternalLinkIcon from './icons/ExternalLinkIcon'
import { linkSelected } from '../utils/analytics'

const ExternalLink = ({ href, children, className, linkName, analyticsContext = {} }) =>
  <a
    href={href}
    class={`ExternalLink ${className || ''}`}
    target='_blank'
    rel='noopener noreferrer'
    onClick={() => linkSelected(linkName, analyticsContext)}
  >
    {children}
    <ExternalLinkIcon />
  </a>

export default ExternalLink
